import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, type Document, type Entity, type Status } from "../api";
import { fmtDate, StatusBadge } from "../ui";

const TABS: { k: Status | "all"; label: string }[] = [
  { k: "all", label: "Tous" },
  { k: "pending", label: "À valider" },
  { k: "review", label: "Révision" },
  { k: "validated", label: "Validés" },
  { k: "draft", label: "Brouillons" },
  { k: "archived", label: "Archives" },
];

export default function EntityView() {
  const { id } = useParams();
  const [entity, setEntity] = useState<Entity | null>(null);
  const [docs, setDocs] = useState<Document[]>([]);
  const [tab, setTab] = useState<Status | "all">("all");

  useEffect(() => {
    api<{ entities: Entity[] }>("/entities").then((r) =>
      setEntity(r.entities.find((e) => e.id === id) || null)
    );
  }, [id]);

  useEffect(() => {
    const q = new URLSearchParams({ entity_id: id! });
    if (tab !== "all") q.set("status", tab);
    api<{ documents: Document[] }>(`/documents?${q}`).then((r) => setDocs(r.documents));
  }, [id, tab]);

  return (
    <>
      <h2>{entity?.name || "…"}</h2>
      <p className="muted">{entity?.short_code} — {entity?.kind}</p>

      <div className="tabs">
        {TABS.map((t) => (
          <button
            key={t.k}
            className={tab === t.k ? "active" : undefined}
            onClick={() => setTab(t.k)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="doc-list">
        {docs.map((d) => (
          <Link key={d.id} to={`/documents/${d.id}`} className="card tap doc-row">
            <div className="title">{d.title}</div>
            <div className="meta">
              <StatusBadge s={d.status} />
              <span className="tiny">{d.created_by_name}</span>
              <span className="tiny">· {fmtDate(d.updated_at)}</span>
            </div>
          </Link>
        ))}
        {docs.length === 0 && <p className="muted">Aucun document dans cette catégorie.</p>}
      </div>

      <div style={{ height: 12 }} />
      <Link to="/documents/new" className="btn btn-primary full">
        + Nouveau document
      </Link>
    </>
  );
}
